import { inject, Injectable } from '@angular/core';
import Intercom, { shutdown, update } from '@intercom/messenger-js-sdk';
import { environment } from '../../../environments/environment';
import { AccountService } from './auth/account.service';

@Injectable({
  providedIn: 'root'
})
export class IntercomService {
  private readonly accountService = inject(AccountService);

  private readonly defaultSettings = {
    app_id: environment.intercomAppId,
    production: environment.production,
    utm_source: 'tap_web',
    widget: {
      activator: '#intercom'
    },
  }

  initialize(): void {
    if (!environment.intercomAppId) {
      console.warn('Intercom app id is not set');
      return;
    }

    const info = this.accountService.getAccountInfo();
    const data = {
      ...this.defaultSettings,
      ...(info && {
        user_id: info.userId ?? undefined,
        name: info.name ?? undefined,
        email: info.email ?? undefined,
        phone: info.phone ?? undefined,
        position: info.position ?? undefined,
        company: info.company ?? undefined
      }),
    };
    Intercom(data);
  }

  identify(): void {
    if (!environment.intercomAppId) {
      return;
    }

    shutdown();
    const info = this.accountService.getAccountInfo();
    if (info) {
      this.initialize();
    }
  }

  reset(): void {
    if (!environment.intercomAppId) {
      return;
    }

    shutdown();
    Intercom(this.defaultSettings);
  }
}
